module.exports = __webpack_public_path__ + "static/media/skull_left.1939ec48.png";